import { AxiosResponse } from 'axios';
import PageableRq from '@domain/rq/common/PageableRq';
import { axios } from '@repository/RequestClient';
import { PhsPositionsRq } from '@domain/rq/phs/center/PhsPositionsRq';
import { PhsKnowledgeAndSkillsRq } from '@domain/rq/phs/center/PhsKnowledgeAndSkillsRq';
import { PhsSkillPositionsRq } from '@domain/rq/phs/center/PhsSkillPositionsRq';
import { PhsContentsRs } from '@domain/rs/phs/center/PhsContentsRs';
import { PhsPositionsRs } from '@domain/rs/phs/center/PhsPositionsRs';
import { PhsResultTypeRs } from '@domain/rs/phs/center/PhsResultTypeRs';
import { PhsKnowledgeAndSkillsRs } from '@domain/rs/phs/center/PhsKnowledgeAndSkillsRs';
import { PhsSkillPositionsRs } from '@domain/rs/phs/center/PhsSkillPositionsRs';

const phsCenterPrefix = '/phs/center';

export default interface PhsCenterRepo {
  // 디챔스 콘텐츠 목록 조회
  fetchPhsCenterContents(rq: PageableRq): Promise<AxiosResponse<PhsContentsRs>>;

  // 개발자 포지션 목록 조회
  fetchPhsCenterPosition(rq: PhsPositionsRq): Promise<AxiosResponse<PhsPositionsRs>>;

  // 개발자 검사 역량 유형 조회
  fetchPhsCenterResultType(): Promise<AxiosResponse<PhsResultTypeRs>>;

  // 지식 기술 키워드 조회
  fetchPhsCenterSkill(): Promise<AxiosResponse<PhsKnowledgeAndSkillsRs>>;

  // 지식 기술 키워드 수정
  fetchPutPhsCenterSkill(rq: PhsKnowledgeAndSkillsRq): Promise<AxiosResponse>;

  // 기술 스택 활용 포지션 조회
  fetchPhsCenterSkillPosition(rq: PhsSkillPositionsRq): Promise<AxiosResponse<PhsSkillPositionsRs>>;
}

export class RemotePhsCenterRepo implements PhsCenterRepo {
  fetchPhsCenterContents(rq: PageableRq): Promise<AxiosResponse<PhsContentsRs>> {
    return axios.get(`${phsCenterPrefix}/contents`, { params: rq });
  }

  fetchPhsCenterPosition(rq: PhsPositionsRq): Promise<AxiosResponse<PhsPositionsRs>> {
    return axios.get(`${phsCenterPrefix}/position`, { params: rq });
  }

  fetchPhsCenterResultType(): Promise<AxiosResponse<PhsResultTypeRs>> {
    return axios.get(`${phsCenterPrefix}/result-type`);
  }

  fetchPhsCenterSkill(): Promise<AxiosResponse<PhsKnowledgeAndSkillsRs>> {
    return axios.get(`${phsCenterPrefix}/skill`);
  }

  fetchPutPhsCenterSkill(rq: PhsKnowledgeAndSkillsRq): Promise<AxiosResponse> {
    return axios.put(`${phsCenterPrefix}/skill`, {
      skills: rq.skills,
    });
  }

  fetchPhsCenterSkillPosition(rq: PhsSkillPositionsRq): Promise<AxiosResponse<PhsSkillPositionsRs>> {
    return axios.get(`${phsCenterPrefix}/skill/position`, { params: rq });
  }
}
